export default __webpack_public_path__ + "static/media/after-cf@2x.e4e4f49d.png";